
import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import POSSystem from './components/POSSystem';
import OrderQueue from './components/OrderQueue';

export default function KasirPage() {
  const [activeTab, setActiveTab] = useState<'pos' | 'orders'>('pos');

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-red-900/20 to-yellow-900/20">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-white mb-4">Panel Kasir</h1>
            <p className="text-xl text-gray-300">Sistem Point of Sales & Manajemen Pesanan</p>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-8">
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-2 border border-red-500/20">
              <div className="flex space-x-2">
                <button
                  onClick={() => setActiveTab('pos')}
                  className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeTab === 'pos'
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <i className="ri-shopping-cart-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                  POS System
                </button>
                <button
                  onClick={() => setActiveTab('orders')}
                  className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeTab === 'orders'
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <i className="ri-file-list-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Antrian Pesanan
                </button>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="bg-gray-800/30 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
            {activeTab === 'pos' && <POSSystem />}
            {activeTab === 'orders' && <OrderQueue />}
          </div>
        </div>
      </div>
    </div>
  );
}